import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from './ui/button';
import { subscribeToPushNotifications } from '../utils/pushNotificationUtils';

const PushNotificationBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isSubscribing, setIsSubscribing] = useState(false);

  useEffect(() => {
    // Check if user has already seen the banner or is subscribed
    const hasSeenBanner = localStorage.getItem('pushBannerShown');
    const isSubscribed = localStorage.getItem('pushSubscribed');
    const hasDismissed = localStorage.getItem('pushBannerDismissed');
    
    // Show banner after 3 seconds if user hasn't seen it, isn't subscribed, and hasn't dismissed it
    if (!hasSeenBanner && !isSubscribed && !hasDismissed) {
      const timer = setTimeout(() => {
        setShowBanner(true);
        localStorage.setItem('pushBannerShown', 'true');
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAllow = async () => {
    setIsSubscribing(true);
    try {
      const success = await subscribeToPushNotifications();
      if (success) {
        setShowBanner(false);
      }
    } catch (error) {
      console.error('Error subscribing:', error);
    } finally {
      setIsSubscribing(false);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pushBannerDismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 flex-1">
              <div className="bg-white/20 rounded-full p-3 animate-pulse">
                <Bell className="h-6 w-6" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-lg mb-1">
                  Stay Updated with Our Latest Offers!
                </h3>
                <p className="text-sm text-blue-100">
                  Enable notifications to receive exclusive deals, service updates, and important announcements.
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Button
                onClick={handleAllow}
                disabled={isSubscribing}
                className="bg-white text-blue-600 hover:bg-blue-50 font-semibold px-6"
              >
                {isSubscribing ? 'Enabling...' : 'Allow Notifications'}
              </Button>
              <Button
                onClick={handleDismiss}
                variant="ghost"
                size="icon"
                className="text-white hover:bg-white/20"
              >
                <X className="h-5 w-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationBanner;
